import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';
import CustomRichText from '../CustomRichText';

export interface OpportunitiesCardProps {
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  listItems?:
    | Array<string>
    | Array<{
        item: ReactNode | SerializedEditorState;
      }>;
  index: number;
}

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

export default function OpportunitiesCard({
  title,
  subtitle,
  listItems,
  index,
}: OpportunitiesCardProps) {
  return (
    <div
      data-meta="OpportunitiesCard"
      className={classNames('flex gap-12 backdrop-blur-sm bg-white/30 rounded-3xl p-8')}
    >
      <div className={classNames('text-white flex flex-col items-center lg:items-start')}>
        <CustomRichText
          data={title}
          tag="div"
          className={classNames(subtitle ? 'mb-6' : '', 'text-xl font-bold min-h-11')}
        />
        <div>
          {subtitle && <CustomRichText data={subtitle} tag="div" />}
          {listItems && (
            <ul className="list-disc pl-4">
              {listItems.map((item, index) => (
                <li key={index}>
                  {typeof item === 'string' ? item : <CustomRichText data={subtitle} tag="div" />}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
